import { all, call, put } from 'redux-saga/effects';
import {
  GET_LOGOUT_REQUEST,
  GET_LOGIN_ERROR,
} from '../services/redux/auth/types';

function* callToAPI({
  apiCall,
  successResponseCode,
  errorType,
  callback,
  payload = null,
}) {
  try {
    let response;
    if (Array.isArray(payload)) {
      response = yield all(payload.map((item) => call(apiCall, item)));
    } else {
      response = yield call(apiCall, payload);
    }
    if (
      (Array.isArray(payload) &&
        response.every((r) => r.status === successResponseCode)) ||
      response.status === successResponseCode
    ) {
      yield callback(response);
    } else {
      if (response.status === 401 && errorType !== GET_LOGIN_ERROR) {
        yield put({ type: GET_LOGOUT_REQUEST });
      } else {
        yield put({ type: errorType, payload: response });
        yield put({
          type: 'CREATE_ERRORS',
          payload: {
            status: response.status,
            errorType: errorType,
            message: response.data?.message,
          },
        });
      }
    }
  } catch (error) {
    yield put({ type: errorType, payload: error });

    yield put({
      type: 'CREATE_ERRORS',
      payload: {
        status: 502,
        errorType: errorType,
      },
    });
  }
}

export default callToAPI;
